
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMoneyBills } from "react-icons/fa6";


function CurrentOrderToolTip() {
    const [isHovered, setIsHovered] = useState(false);
    const { t } = useTranslation();

    return (
        <span
            className={` relative cursor-pointer    text-yellow-600 "
                }`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <FaMoneyBills size={20} />

            {isHovered && (
                <span
                    className={`absolute  -top-12
                         z-[999] w-max max-w-[200px] rounded bg-yellow-200 px-3 py-2 text-center text-xs font-semibold text-yellow-800 shadow-md`}
                >
                    {t("tableOrders.thisTable")}
                </span>
            )}
        </span>
    );
}

export default CurrentOrderToolTip;
